module.exports = __webpack_public_path__ + "static/media/right-web.3560b6ff.svg";